import React, {FC, useEffect, useState} from "react"

import {Checkbox} from "@irati/ui/src/FormItem"
import idHelper from "@irati/utils/id"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import getTermsAndConditionsUrl from "@irati/deals/helpers/deals/getTermsAndConditionsUrl"
import Link from "@irati/ui/src/Link"
import {Body, H4} from "@irati/ui/src/Typography"
import {Strong} from "@irati/ui/src/Labels"

import {TermsAndConditionsWrapper} from "./styled/TermsAndConditions"

interface Props extends InjectIntl {
  onChange: () => void,
  termsAgreed?: boolean,
  id?: string
}

const TermsAndConditions: FC<Props> = ({onChange, termsAgreed, ...props}) => {
  const name = idHelper("checkbox", props)

  const [termsLink, setTermsLink] = useState<string | undefined>(undefined)

  useEffect(() => {
    getTermsAndConditionsUrl().then((url) => {
      setTermsLink(url)
    })
  }, [])

  return (
    <>
      <H4 margin={[4, 0, 2]}>
        <FormattedMessage
          id="perks.components.productForms.nonRefundablePayment.header"
          values={{
            boldText: (
              <Strong>
                <FormattedMessage id="perks.components.productForms.nonRefundablePayment.boldText" />
              </Strong>
            )
          }} />
      </H4>
      <Body>
        <FormattedMessage id="perks.components.productForms.termsAndConditions.header" />
      </Body>
      <TermsAndConditionsWrapper>
        <Checkbox name={name} onChange={onChange} checked={termsAgreed} />
        <label htmlFor={name} id={idHelper("label", props)}>
          <FormattedMessage
            id="perks.components.productForms.termsAndConditions.newBody"
            values={{
              link: (
                <Link cta href={termsLink} target="_blank">
                  <FormattedMessage id="perks.components.productForms.termsAndConditions.link.text" />
                </Link>
              )
            }} />
        </label>
      </TermsAndConditionsWrapper>
    </>
  )
}

TermsAndConditions.defaultProps = {
  id: "termsAndConditions",
  termsAgreed: false
}

export default injectIntl(TermsAndConditions)
